import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./App.css";
import App from "./App";

import { ThemeProvider } from "./context/ThemeContext";

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <React.StrictMode>
    
      <ThemeProvider>
        <App />
      </ThemeProvider>
    
  </React.StrictMode>
);